/**
 * Generates a personalized greeting message based on the time of day and day of week
 * @param firstName - The user's first name
 * @returns A warm, professional greeting message
 */
export function getPersonalizedGreeting(firstName?: string): string {
  const now = new Date();
  const hour = now.getHours();
  const day = now.getDay(); // 0 = Sunday, 6 = Saturday
  const isWeekend = day === 0 || day === 6;

  // Extract first name (take first word before space if full name provided)
  const name = firstName?.split(" ")[0] || "";

  // Weekend messages
  if (isWeekend) {
    if (hour >= 6 && hour < 12) {
      return name
        ? `Bon week-end matinal, ${name} !`
        : "Bon week-end matinal !";
    } else if (hour >= 12 && hour < 18) {
      return name
        ? `Une petite session de week-end, ${name} ?`
        : "Profitez de votre week-end !";
    } else {
      return name
        ? `Belle soirée de week-end, ${name} !`
        : "Belle soirée de week-end !";
    }
  }

  // Get day name in French
  const dayNames = [
    "dimanche",
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi",
  ];
  const dayName = dayNames[day];

  // Weekday messages
  if (hour >= 5 && hour < 9) {
    // Early morning (5h-9h)
    return name
      ? `Excellent ${dayName} matin, ${name} !`
      : `Excellent ${dayName} matin !`;
  } else if (hour >= 9 && hour < 12) {
    // Late morning (9h-12h)
    return name ? `Belle matinée, ${name} !` : "Belle matinée !";
  } else if (hour >= 12 && hour < 14) {
    // Lunch time (12h-14h)
    return name
      ? `Bon ${dayName} midi, ${name} !`
      : `Bon ${dayName} midi !`;
  } else if (hour >= 14 && hour < 18) {
    // Afternoon (14h-18h)
    return name
      ? `Bel après-midi, ${name} !`
      : "Bel après-midi !";
  } else if (hour >= 18 && hour < 22) {
    // Evening (18h-22h)
    return name
      ? `Belle soirée, ${name} !`
      : "Belle soirée !";
  } else {
    // Late night/early morning (22h-5h)
    return name
      ? `Bonsoir ${name} !`
      : "Bonsoir !";
  }
}
